export default __webpack_public_path__ + "ac8c21685718124bafacb1cb4e1316af.jpg";